define("auth/controllers/application", ["exports", "@ember/controller", "@ember/object", "@ember/service", "@glimmer/tracking", "later/utils/constants"], function (_exports, _controller, _object, _service, _tracking, _constants) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;
  /* eslint-disable @latermedia/later-linting/use-snake-case-query-params */
  0; //eaimeta@70e063a35619d71f0,"@ember/controller",0,"@ember/object",0,"@ember/service",0,"@glimmer/tracking",0,"later/utils/constants"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
  function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
  let UserController = _exports.default = (_class = class UserController extends _controller.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "auth", _descriptor, this);
      _initializerDefineProperty(this, "intl", _descriptor2, this);
      _initializerDefineProperty(this, "router", _descriptor3, this);
      _initializerDefineProperty(this, "session", _descriptor4, this);
      _defineProperty(this, "queryParams", _constants.MARKETING_QUERY_PARAMS);
      _initializerDefineProperty(this, "isSsoLogin", _descriptor5, this);
    }
    get searchParams() {
      const searchParams = new URLSearchParams(window.location.search);
      return Object.fromEntries(searchParams.entries());
    }
    get childRouteName() {
      const path = this.router.currentRouteName.split('.');
      return path ? path[path.length - 1] : 'otherPages';
    }
    get isCampaign() {
      return this.router.currentRouteName.includes('campaigns');
    }
    get isAuthenticated() {
      return this.session.isAuthenticated;
    }
    get isCreatingAccount() {
      return this.childRouteName === 'signup' || this.childRouteName === 'welcome';
    }
    get isResettingPassword() {
      return this.childRouteName === 'update_password';
    }
    get isLoggingIn() {
      return this.childRouteName === 'login';
    }
    get childRoutePageTitle() {
      const pageTitles = {
        accept_invite: this.intl.t('shared_words.invitation'),
        login: this.intl.t('authorization.sign_in_form.title'),
        signup: this.intl.t('authorization.create_account.page_title'),
        welcome: this.intl.t('authorization.create_account.page_title'),
        forgot_email: this.intl.t('authorization.forgot_email_page.page_title'),
        reset_password: this.intl.t('authorization.forgot_password.page_title'),
        update_password: this.intl.t('shared_phrases.reset_password'),
        'o-auth': '',
        otherPages: ''
      };
      return pageTitles[this.childRouteName];
    }
    logout() {
      this.auth.logout.perform();
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "router", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "session", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "isSsoLogin", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _applyDecoratedDescriptor(_class.prototype, "logout", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "logout"), _class.prototype)), _class);
});